/* eslint-disable import/no-named-as-default */
import { FC, ReactElement } from 'react'
import CookieConsent from 'react-cookie-consent'

import { defaultUpgradeMessageProperties, defaultUpgradeBrowserStyleClasses } from '../../constants/upgradeBrowser'
import { useI18n } from '../../hooks'

const UpgradeBrowser: FC = (): ReactElement => {
  const { t } = useI18n()
  return (
    <CookieConsent
      location={defaultUpgradeMessageProperties.location}
      buttonText={defaultUpgradeMessageProperties.buttonText}
      style={{ position: 'relative', padding: '10px 5%' }}
      buttonClasses={defaultUpgradeBrowserStyleClasses.buttonClasses}
    >
      {t('UpgradeBrowserMessage')}
    </CookieConsent>
  )
}

export default UpgradeBrowser
